import "./button_link.css";
import { Shevron_Icon } from "../../icons/icons.tsx";

export interface ButtonLinkProps {
  title?: string;
  onClick?: () => void;
  className?: string;
}

export const ButtonLink = ({
  title,
  onClick,
  className = "",
}: ButtonLinkProps) => {
  return (
    <div className={`${className} buttonLink`} onClick={onClick}>
      {title}
      <Shevron_Icon />
    </div>
  );
};
